import React from 'react';
import PropTypes from 'prop-types';
import AuthService from '../../utils/authentication/auth.service';
import {
  Route,
  Redirect
} from 'react-router-dom';

const auth = new AuthService();

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    auth.isAuthenticated()
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/login'
      }} />
  )} />
);

PrivateRoute.propTypes = {
  component: PropTypes.object.isRequired
};

export default PrivateRoute;
